import { Button, Form, Input, Drawer, Card, Modal, message, Space, Spin, Tag } from "antd";
import { CloseOutlined, TagOutlined } from "@ant-design/icons";
import "moment/locale/vi"; // Import locale tiếng Việt
import React, { useEffect, useState, useRef } from "react";
import $axios from "../../services/axios";
import _ from "lodash";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import polyline from "@mapbox/polyline";
import {
  faArrowLeft,
  faPeopleArrows,
  faPhone,
  faUser,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import goongjs from "@goongmaps/goong-js";
import "@goongmaps/goong-js/dist/goong-js.css";
import { listVehicle } from "../../helpers/const";
import sha256 from 'crypto-js/sha256';
import moment from "moment";

const Map = ({
  setStep,
  setLoading,
  loading,
  dataServices,
  dataPlace,
  setDataServices,
}) => {
  const history = useHistory();
  const [openNote, setOpenNote] = useState(false);
  const [openVoucher, setOpenVoucher] = useState(false);
  const [voucherValue, setVoucherValue] = useState(0);
  const [voucherCode, setVoucherCode] = useState("");
  const [voucherTxt, setVoucherTxt] = useState("");
  const [isModalBookingfor, setIsModalBookingfor] = useState(false);
  const [form] = Form.useForm();
  const mapRef = useRef(null); // Thêm useRef để lưu trữ instance của map
  const markersRef = useRef([]);
  const dataLegRef = useRef(null);
  const [addPrice, setAddPrice] = useState(0);
  const [vehicleChoose, setVehicleChoose] = useState(dataServices?.services[0]);
  const [vehicles, setVehicles] = useState(dataServices?.services);
  const [bookForUser, setBookForUser] = useState(false);
  const [userBookingFor, setUserBookingFor] = useState(null);
  const [noteTxt, setNoteTxt] = useState("");
  const [vouchers, setVouchers] = useState([]);
  const [loadingVouchers, setLoadingVouchers] = useState(false);
  const [manualVoucherCode, setManualVoucherCode] = useState("");
  const [loadingManualVoucher, setLoadingManualVoucher] = useState(false);
  const [appliedVoucher, setAppliedVoucher] = useState(null);
  const MAX_FEE = 9000000;

  useEffect(() => {
    setLoading(true);
    getAddPrice();
    if (typeof window !== "undefined") {
      // Phòng trường hợp SSR
      const initMap = (coords) => {
        goongjs.accessToken = process.env.REACT_APP_GOOGNG_MAP_KEY;
        const defaultCoords = [105.854444, 21.029449]; // Tọa
        mapRef.current = new goongjs.Map({
          container: "map",
          center: coords ? [coords.longitude, coords.latitude] : defaultCoords,
          zoom: 15,
          style: "https://tiles.goong.io/assets/goong_map_web.json",
          attributionControl: false,
        });

        mapRef.current.on("load", () => {
          // Gọi hàm calculateAndDisplayRoute sau khi map đã load
          calculateAndDisplayRoute();
          setLoading(false);
        });
      };

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            initMap(position.coords);
          },
          (err) => {
            console.error("Lỗi khi lấy vị trí: ", err);
            initMap(); // Fallback location
          }
        );
      } else {
        initMap(); // Fallback location
      }
    }
  }, []);

  useEffect(() => {
    if (dataServices.services.length > 0) {
      setVehicleChoose(dataServices.services[0]);
    }
  }, [dataServices]);

  const handleBooking = async () => {
    try {
      setLoading(true);
      if (!dataPlace.from || !dataPlace.to || !dataLegRef.current) return;
      const body = {
        ServiceId: vehicleChoose?.id.toString() || "0",
        ServiceName: vehicleChoose?.name || "",
        Note: noteTxt,
        Distance: dataLegRef.current.distance,
        Duration: dataLegRef.current.duration,
        Surge: 1,
        StartPointName: dataPlace.from.placeName,
        StartPointGeocode: dataPlace.from.description,
        StartPointX: dataPlace.from.lat.toString(),
        StartPointY: dataPlace.from.lng.toString(),
        EndPointName: dataPlace.to.placeName,
        EndPointGeocode: dataPlace.to.description,
        EndPointX: dataPlace.to.lat.toString(),
        EndPointY: dataPlace.to.lng.toString(),
        VoucherCode: voucherCode || "",
        Amount:
          Math.max(
            (Number(vehicleChoose?.fee) || 0) + Number(addPrice) -
            Number(voucherValue || 0),
            0
          ).toString() || "0",
        AmountOriginal: (
          (Number(vehicleChoose?.fee) || 0) + Number(addPrice)
        ).toString() || "0",
        AmountDiscount: voucherValue.toString() || "0",
        VatFullName: "",
        VatMst: "",
        VatCompany: "",
        VatEmail: "",
      };
      body.InfoOrder = JSON.stringify({
        StartPointName: body.StartPointName,
        EndPointName: body.EndPointName,
        Distance: body.Distance,
        Amount: body.Amount,
        Service: "taxi",
        Sponsor: "IPASS",
        VoucherCode: voucherCode || "",
        VoucherValue: voucherValue || 0,
      });
      const resPayment = await $axios.$post(
        "/api/v1/gsm/payment/paymentRequired",
        body
      );
      if (resPayment.data.data.orderId) {
        const orderId = resPayment.data.data.orderId;
        if (
          window.webkit &&
          window.webkit.messageHandlers &&
          window.webkit.messageHandlers.NativeJavascriptInterface
        ) {
          // Chuyển đổi dữ liệu thành chuỗi JSON và gửi qua Swift
          window.webkit.messageHandlers.NativeJavascriptInterface.postMessage({
            orderCode: orderId,
          });
        } else {
          console.error(
            "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ."
          );
        }
        // Send orderCode for Android
        if (window.webkit !== undefined) {
          if (window.webkit.messageHandlers.appInterface !== undefined) {
            window.webkit.messageHandlers.appInterface.postMessage(
              JSON.stringify({
                orderCode: orderId,
              })
            );
          }
        }
        if (window.appInterface !== undefined) {
          window.appInterface.postMessage(
            JSON.stringify({
              orderCode: orderId,
            })
          );
        }

      }
    } catch (error) {
      message.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const getVouchers = async (targetVehicle) => {
    const vehicle = targetVehicle || vehicleChoose;
    const total = (Number(vehicle?.fee) || 0) + (Number(addPrice) || 0);
    if (!total) return;
    setLoadingVouchers(true);
    try {
      let res;
      try {
        res = await $axios.$post("/api/v1/gsm/payment/getVoucherByOrder", {
          Quantity: 1,
          Total: total,
        });
      } catch (err) {
        if (err?.response?.status === 404 || err?.response?.status === 405) {
          res = await $axios.$post("/api/v1/voucher/getVoucherByOrder", {
            Quantity: 1,
            Total: total,
          });
        } else {
          throw err;
        }
      }
      const list = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
        ? res.data
        : [];
      const now = moment();
      const validVouchers = list.filter((voucher) => {
        const start = voucher.startDate || voucher.start_date;
        const end = voucher.endDate || voucher.end_date;
        if (!start || !end) return true;
        return now.isBetween(moment(start), moment(end), null, "[]");
      });
      setVouchers(validVouchers);
    } catch (error) {
      console.error("Lỗi khi tải danh sách voucher:", error);
    } finally {
      setLoadingVouchers(false);
    }
  };

  const getServicesEstimates = async () => {
    try {
      const res = await $axios.$post("/api/v1/gsm/services/estimates", {
        Distance: dataLegRef.current.distance,
        Duration: dataLegRef.current.duration,
        RegionId: dataServices.regionId,
        Waypoints: dataLegRef.current.waypoints,
      });
      if (res) {
        const services = _.cloneDeep(dataServices.services);
        for (let index = 0; index < services.length; index++) {
          const item = services[index];
          const checkExits = res.data.data.prices.find(
            (itemFind) => itemFind.serviceId === item.id
          );
          if (checkExits) {
            services[index].fee = checkExits.totalPrice;
          }
        }
        if (_.some(services, (s) => s.fee >= MAX_FEE)) {
          setStep("booking");
          message.warning(
            "Giá cước vượt giới hạn. Vui lòng điều chỉnh điểm đến hoặc chia chuyến để đặt xe!"
          );
        }
        setVehicles(services);
        const firstService = services[0];
        setVehicleChoose(firstService);
        setDataServices({ ...dataServices, services });
        getVouchers(firstService);
      }
    } catch (error) {
      message.error(
        error.response.data.message || "Không tìm thấy dữ liệu chuyến đi!"
      );
      setStep("booking");
    } finally {
      getVouchers();
    }
  };

  const createCustomMarker = (iconUrl, size) => {
    const el = document.createElement("div");
    el.className = "custom-marker";
    el.style.backgroundImage = `url(${iconUrl})`;
    el.style.width = `${size}px`;
    el.style.height = `${size}px`;
    el.style.backgroundSize = "cover";
    return el;
  };

  const createMarker = (latlng, icon, content, title, size = 20) => {
    // Thêm một marker với icon tùy chỉnh
    // @ts-ignore
    const marker = new goongjs.Marker({
      element: createCustomMarker(icon, size),
    })
      .setLngLat([latlng.lng, latlng.lat]) // Tọa độ (Kinh độ, Vĩ độ)
      .addTo(mapRef.current);

    // @ts-ignore
    const popup = new goongjs.Popup({ offset: 25 }).setHTML(content);

    marker.setPopup(popup);
    popup.addTo(mapRef.current);
    markersRef.current.push(marker);
  };

  const calculateAndDisplayRoute = async () => {
    const request = {
      origin: { lat: dataPlace.from?.lat, lng: dataPlace.from?.lng },
      destination: { lat: dataPlace.to?.lat, lng: dataPlace.to?.lng },
    };

    mapRef.current?.setCenter(request.origin);

    let layers = mapRef.current?.getStyle().layers;
    // Find the index of the first symbol layer in the map style
    let firstSymbolId;
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].type === "symbol") {
        firstSymbolId = layers[i].id;
        break;
      }
    }

    const res = await $axios.$get(
      `https://rsapi.goong.io/Direction?origin=${request.origin.lat},${request.origin.lng}&destination=${request.destination.lat},${request.destination.lng}&vehicle=car&api_key=${process.env.REACT_APP_GOOGNG_API_KEY}`
    );

    if (res.data.routes && res.data.routes.length > 0) {
      const route = res.data.routes[0];

      const geometry_string = route.overview_polyline.points;
      // @ts-ignore
      const geoJSON = polyline.toGeoJSON(geometry_string);
      mapRef.current?.addSource("route", {
        type: "geojson",
        data: geoJSON,
      });
      // Add route layer below symbol layers
      mapRef.current.addLayer(
        {
          id: "route",
          type: "line",
          source: "route",
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#1e88e5",
            "line-width": 5,
          },
        },
        firstSymbolId
      );

      const leg = res.data.routes[0].legs[0];
      dataLegRef.current = {
        distance: leg.distance.value / 1000,
        duration: leg.duration.value / 60,
        waypoints: [
          {
            X: leg.start_location.lat,
            Y: leg.start_location.lng,
          },
          {
            X: leg.end_location.lat,
            Y: leg.end_location.lng,
          },
        ],
      };
      createMarker(
        leg.start_location,
        "/images/person-wave-hand.png",
        `
              <div style="display: flex;padding: 4px;">
                <p style="font-size: 12px; padding-right: 8px; border-right: 1px solid #000;">${leg.duration.text}</p>
                <p style="font-size: 12px; max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;margin-left: 8px;">${leg.start_address}</p>
              </div>
            `,
        leg.start_address
      );

      createMarker(
        leg.end_location,
        "/images/svg/flag-icon.svg",
        `
              <div style="display: flex;padding: 4px 2px;">
                <p style="font-size: 12px; max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${leg.end_address}</p>
              </div>
            `,
        leg.end_address,
        50
      );
      await getServicesEstimates();
    }
  };

  const getAddPrice = async () => {
    try {
      const res = await $axios.$get(`/api/v1/gsm/payment/getAddPrice`);
      if (res.data.data.data.status === 1) {
        const amount = _.get(res, "data.data.data.amount", 0);
        setAddPrice(amount);
        return amount;
      }
    } catch (error) {
    } finally {
    }
  };

  const focusCurrentLocation = () => {
    const origin = {
      lat: dataPlace.from?.lat,
      lng: dataPlace.from?.lng,
    };
    mapRef.current.setCenter(origin);
    mapRef.current.setZoom(15);
  };

  const handleClearVoucher = () => {
    setVoucherValue(0);
    setVoucherCode("");
    setManualVoucherCode("");
    setVoucherTxt("");
    setAppliedVoucher(null);
  };

  const applyVoucherPick = (voucher, targetVehicle, showToast = true) => {
    if (!voucher) return;
    const vehicle = targetVehicle || vehicleChoose;
    const currentTotal =
      (Number(vehicle?.fee) || 0) + (Number(addPrice) || 0);

    const code =
      voucher.code ||
      voucher.voucherCode ||
      voucher.voucher_code ||
      manualVoucherCode;
    const discountType =
      voucher.discountType || voucher.discount_type || "FIXED_AMOUNT";

    let amount = 0;
    if (discountType === "PERCENTAGE") {
      const pct =
        Number(
          voucher.discountValue || voucher.discount_value || voucher.amount
        ) || 0;
      const discount = Math.ceil(currentTotal * (pct / 100));
      const maxDiscount =
        voucher.maxDiscountValue || voucher.max_discount_value;
      amount = maxDiscount ? Math.min(discount, Number(maxDiscount)) : discount;
    } else {
      amount =
        Number(
          voucher.amountVoucher ||
            voucher.amount ||
            voucher.discountValue ||
            voucher.discount_value
        ) || 0;
    }

    if (currentTotal > 0) {
      amount = Math.min(amount, currentTotal);
    }

    if (amount > 0) {
      setVoucherValue(amount);
      setVoucherCode(code);
      setManualVoucherCode(code);
      setAppliedVoucher({ ...voucher, code });
      setVoucherTxt(
        `<div class="text-[14px]">Áp dụng mã giảm giá thành công! <span class="text-green-600 font-bold text-[15px]">-${amount.toLocaleString(
          "vi-VN"
        )} đ</span></div>`
      );
      if (showToast) {
        message.success(`Áp dụng mã giảm giá ${code} thành công!`);
        setOpenVoucher(false);
      }
    } else {
      if (showToast) {
        const errMsg =
          voucher?.message ||
          (voucher.status === 0
            ? "Mã giảm giá không hợp lệ hoặc đã hết lượt dùng!"
            : "Mã giảm giá không hợp lệ!");
        setVoucherTxt(`<div class="text-[14px] text-red-600">${errMsg}</div>`);
        message.error(errMsg);
      }
      handleClearVoucher();
    }
  };

  const applyManualVoucher = async (e) => {
    const code = (
      typeof e === "string" && e.trim() ? e : manualVoucherCode
    ).trim();
    if (!code) {
      setVoucherTxt(
        `<div class="text-[14px] text-red-600">Vui lòng nhập mã giảm giá!</div>`
      );
      return;
    }

    setLoadingManualVoucher(true);
    const totalAmount =
      (Number(vehicleChoose?.fee) || 0) + (Number(addPrice) || 0);

    try {
      let res;
      try {
        res = await $axios.$post("/api/v1/gsm/payment/getVoucher", {
          Quantity: 1,
          Total: totalAmount,
          VoucherCode: code,
        });
      } catch (postErr) {
        if (
          postErr?.response?.status === 404 ||
          postErr?.response?.status === 405
        ) {
          try {
            res = await $axios.$get(
              `/api/v1/gsm/payment/getVoucher?voucherCode=${encodeURIComponent(
                code
              )}`
            );
          } catch (gsmGetErr) {
            if (
              gsmGetErr?.response?.status === 404 ||
              gsmGetErr?.response?.status === 405
            ) {
              res = await $axios.$get(
                `/api/v1/voucher/getVoucher?voucherCode=${encodeURIComponent(
                  code
                )}`
              );
            } else {
              throw gsmGetErr;
            }
          }
        } else {
          throw postErr;
        }
      }

      const rawData = res?.data?.data !== undefined ? res.data.data : res?.data;
      const voucherData = Array.isArray(rawData) ? rawData[0] : rawData;
      if (
        voucherData &&
        (voucherData.status === undefined ||
          voucherData.status === 1 ||
          voucherData.status === true ||
          voucherData.status === "SUCCESS") &&
        (Number(voucherData.amount) > 0 ||
          Number(voucherData.discountValue) > 0 ||
          Number(voucherData.amountVoucher) > 0)
      ) {
        applyVoucherPick({ ...voucherData, code: voucherData.code || code });
      } else {
        const errMsg =
          voucherData?.message ||
          res?.data?.message ||
          res?.message ||
          "Mã giảm giá không hợp lệ!";
        setVoucherTxt(`<div class="text-[14px] text-red-600">${errMsg}</div>`);
        message.error(errMsg);
        handleClearVoucher();
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || "Mã giảm giá không hợp lệ!";
      setVoucherTxt(`<div class="text-[14px] text-red-600">${errMsg}</div>`);
      message.error(errMsg);
      handleClearVoucher();
    } finally {
      setLoadingManualVoucher(false);
    }
  };

  const handleFinish = async (values) => {
    setUserBookingFor({
      phone: values.phone,
      fullName: values.fullName,
    });
    setBookForUser(true);
    setIsModalBookingfor(false);
  };

  return (
    <div className="relative flex flex-col h-[100vh] bg-white">
      <div id="map" className="flex-1 max-h-[100%]"></div>
      {/* <div class="marker-center">
      <img src="/images/mark.svg" alt="icon" class="w-4" />
    </div> */}
      <div className="flex flex-col bg-white relative py-4">
        <div className="flex justify-between absolute top-[-40px] w-full px-4">
          <div className="flex gap-3">
            <Button color="primary" variant="outlined">
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="text-primary"
                onClick={() => setStep("booking")}
              />
            </Button>

            <Button
              color="primary"
              variant="outlined"
              onClick={() => setIsModalBookingfor(true)}
            >
              <FontAwesomeIcon icon={faPeopleArrows} className="text-primary" />
              <span className="font-semibold">
                {bookForUser ? userBookingFor.fullName : "Đặt hộ"}
              </span>
              {bookForUser && (
                <FontAwesomeIcon
                  icon={faClose}
                  className="text-primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    form.resetFields();
                    setBookForUser(false);
                    setUserBookingFor(null);
                  }}
                />
              )}
            </Button>
          </div>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => focusCurrentLocation()}
          >
            <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1">
              <defs></defs>
              <g
                id="Home-2"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g id="1-Home" transform="translate(-259.000000, -279.000000)">
                  <g
                    id="ic_current"
                    transform="translate(259.000000, 279.000000)"
                  >
                    <circle
                      id="Oval"
                      stroke="currentColor"
                      stroke-width="2"
                      fill="#FFFFFF"
                      cx="8.5"
                      cy="8.5"
                      r="7.5"
                    ></circle>
                    <circle
                      id="Oval"
                      fill="currentColor"
                      cx="8.5"
                      cy="8.5"
                      r="4.25"
                    ></circle>
                  </g>
                </g>
              </g>
            </svg>
          </Button>
        </div>
        <div className="flex flex-col gap-4 px-4">
          {vehicles.length > 0 &&
            vehicleChoose &&
            vehicles?.map((vehicle) => (
              <div
                key={vehicle.id}
                onClick={() => {
                  setVehicleChoose(vehicle);
                  if (appliedVoucher) {
                    applyVoucherPick(appliedVoucher, vehicle, false);
                  }
                }}
                className={`items-center ${vehicleChoose.id === vehicle.id
                  ? "border border-primary border-solid"
                  : "bg-[#f3f4f6]"
                  } flex p-4 justify-between rounded-xl`}
              >
                <div className="flex gap-4 items-center justify-center">
                  <img src={vehicle?.imgMain} alt="" className="w-[64px]" />
                  <div className="flex flex-col gap-2">
                    <div className="text-[14px] font-semibold">
                      {vehicle?.name.replace("Emddi Fixed", "IpassGo")}
                    </div>
                    <div className="text-[12px] font-semibold">
                      {listVehicle[vehicle?.vehicleType]?.seatCount} chỗ
                    </div>
                  </div>
                </div>
                {vehicle?.fee && (
                  <div className="flex flex-col gap-2">
                    <div
                      className={`text-[16px] font-semibold ${voucherValue > 0 ? "line-through !text-[14px]" : ""
                        }`}
                    >
                      {((vehicle?.fee || 0) + addPrice).toLocaleString("vi-VN")} đ
                    </div>
                    {voucherValue > 0 && (
                      <div className="text-[16px] font-semibold text-green-500">
                        {Math.max(
                          (vehicle?.fee || 0) + addPrice - voucherValue,
                          0
                        ).toLocaleString("vi-VN")}{" "}
                        đ
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
        </div>
        <div className="px-4 mt-4">
          <div className="flex justify-between items-center">
            <div
              className="w-1/2 text-center text-sm font-semibold flex items-center justify-center gap-1 cursor-pointer"
              onClick={() => {
                if (vouchers.length === 0) {
                  getVouchers();
                }
                setOpenVoucher(true);
              }}
            >
              {voucherCode && voucherValue > 0 ? (
                <Tag
                  color="success"
                  className="m-0 py-0.5 px-2 text-xs flex items-center gap-1 rounded-full cursor-pointer"
                >
                  <TagOutlined />
                  <span>
                    {voucherCode} (-{voucherValue.toLocaleString("vi-VN")}đ)
                  </span>
                  <CloseOutlined
                    className="text-red-500 hover:text-red-700 ml-1 text-xs"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleClearVoucher();
                    }}
                  />
                </Tag>
              ) : (
                <span className="hover:text-primary transition-colors">
                  Khuyến mãi
                </span>
              )}
            </div>
            <div
              className="w-1/2 text-center text-sm font-semibold cursor-pointer hover:text-primary transition-colors"
              onClick={() => setOpenNote(true)}
            >
              {noteTxt ? (
                <span className="text-primary truncate max-w-[120px] inline-block align-bottom">
                  {noteTxt}
                </span>
              ) : (
                "Ghi chú"
              )}
            </div>
          </div>
          <Button
            className=" w-full mt-4"
            size="large"
            variant="solid"
            color="primary"
            onClick={() => handleBooking()}
          >
            <span className="text-[16px] font-bold text-white">Đặt Xe</span>
          </Button>
        </div>
      </div>

      <Drawer
        title={
          <div className="flex flex-col gap-4">
            <div className="flex justify-between">
              <span className="uppercase font-bold tex-[20px]"> Ghi chú</span>
              <CloseOutlined
                onClick={() => setOpenNote(false)}
                style={{ fontSize: 18, cursor: "pointer" }}
              />
            </div>
          </div>
        }
        footer={
          <Button
            variant="solid"
            color="primary"
            size="large"
            className="w-full"
            onClick={() => {
              setOpenNote(false);
            }}
          >
            <span className="text-[16px] font-semibold "> Lưu</span>
          </Button>
        }
        placement={"bottom"}
        closable={false}
        onClose={() => setOpenNote(false)}
        open={openNote}
        height={"100%"}
      >
        <Card variant="borderless" className="w-full">
          <div className="text-[16px] font-semibold mb-4">
            Ghi chú cho tài xế
          </div>
          <Input.TextArea
            rows={4}
            placeholder="Nhập ghi chú"
            value={noteTxt}
            onChange={(e) => setNoteTxt(e.target.value)}
            allowClear
          />
        </Card>
      </Drawer>

      <Drawer
        title={
          <div className="flex flex-col gap-3">
            <div className="flex justify-between items-center">
              <span className="uppercase font-bold text-base text-gray-800">
                Mã giảm giá
              </span>
              <CloseOutlined
                onClick={() => setOpenVoucher(false)}
                style={{ fontSize: 18, cursor: "pointer" }}
              />
            </div>
            <div>
              <Space.Compact style={{ width: "100%", display: "flex" }}>
                <Input
                  placeholder="Nhập mã giảm giá khác..."
                  allowClear
                  value={manualVoucherCode}
                  onChange={(e) => {
                    setManualVoucherCode(e.target.value);
                    if (voucherTxt) setVoucherTxt("");
                  }}
                  onPressEnter={() => applyManualVoucher(manualVoucherCode)}
                  className="h-10 text-sm"
                  style={{ flex: 1 }}
                />
                <Button
                  type="primary"
                  className="!bg-primary text-white font-medium h-10 px-5 flex-shrink-0"
                  style={{
                    backgroundColor: "#0064D2",
                    borderColor: "#0064D2",
                    color: "#ffffff",
                  }}
                  loading={loadingManualVoucher}
                  onClick={() => applyManualVoucher(manualVoucherCode)}
                >
                  Áp dụng
                </Button>
              </Space.Compact>
              {voucherTxt && (
                <div
                  className="mt-2 text-xs"
                  dangerouslySetInnerHTML={{ __html: voucherTxt }}
                />
              )}
            </div>
          </div>
        }
        placement="bottom"
        closable={false}
        onClose={() => setOpenVoucher(false)}
        open={openVoucher}
        height="80%"
        bodyStyle={{
          background: "#f8fafc",
          padding: "16px",
        }}
      >
        <div className="flex flex-col gap-3">
          {loadingVouchers ? (
            <div className="py-12 flex flex-col items-center justify-center gap-2 text-gray-400">
              <Spin />
              <span className="text-sm">Đang tải mã giảm giá...</span>
            </div>
          ) : vouchers.length === 0 ? (
            <div className="py-12 text-center text-gray-400 text-sm">
              Không có mã giảm giá khả dụng
            </div>
          ) : (
            vouchers.map((voucher, idx) => {
              const code =
                voucher.code ||
                voucher.voucherCode ||
                voucher.voucher_code ||
                `VOUCHER_${idx}`;
              const desc =
                voucher.title ||
                voucher.description ||
                (Number(
                  voucher.amount ||
                    voucher.discountValue ||
                    voucher.amountVoucher
                ) > 0
                  ? `Giảm ${Number(
                      voucher.amount ||
                        voucher.discountValue ||
                        voucher.amountVoucher
                    ).toLocaleString("vi-VN")} đ`
                  : "");
              const endDate = voucher.endDate || voucher.end_date;

              return (
                <div
                  key={voucher.id || code}
                  className="rounded-xl bg-white p-3.5 shadow-sm border border-gray-100 flex gap-3 items-center hover:border-blue-200 transition-colors"
                >
                  <img
                    src="/images/logo-taxi.jpg"
                    className="w-12 h-12 rounded-lg object-contain shrink-0"
                    alt="Voucher"
                  />
                  <div className="flex flex-col flex-1 min-w-0">
                    <div className="font-bold text-sm text-primary truncate">
                      Mã: {code}
                    </div>
                    {desc && (
                      <div className="text-red-500 text-xs font-semibold mt-0.5 line-clamp-2">
                        {desc}
                      </div>
                    )}
                    {endDate && (
                      <div className="text-gray-400 text-[11px] mt-1">
                        Áp dụng đến:{" "}
                        {moment(endDate).format("HH:mm DD/MM/YYYY")}
                      </div>
                    )}
                  </div>
                  <Button
                    type="primary"
                    size="small"
                    className="!bg-primary text-white font-medium shrink-0 rounded-lg text-xs"
                    style={{
                      backgroundColor: "#0064D2",
                      borderColor: "#0064D2",
                      color: "#ffffff",
                    }}
                    onClick={() => applyVoucherPick(voucher)}
                  >
                    Áp dụng
                  </Button>
                </div>
              );
            })
          )}
        </div>
      </Drawer>

      <Modal
        open={isModalBookingfor}
        title={
          <div className="text-primary text-[20px] font-bold">
            Đặt hộ xe người khác
          </div>
        }
        onCancel={() => setIsModalBookingfor(false)}
        footer={null}
        style={{ top: 0, padding: 0 }}
        width="100vw"
        centered={true}
      >
        <Form
          form={form}
          onFinish={handleFinish}
          layout="vertical"
          onFinishFailed={(values) => { }}
          className="w-full"
        >
          <div className="w-full">
            <Form.Item
              name="fullName"
              label="Họ và tên"
              rules={[
                {
                  required: true,
                  message: "Họ và tên không được để trống",
                },
              ]}
              className="mb-3 w-full"
            >
              <Input
                size="large"
                prefix={
                  <FontAwesomeIcon icon={faUser} className="text-primary" />
                }
                placeholder="Họ và tên"
              />
            </Form.Item>
          </div>
          <Form.Item
            name="phone"
            label="Số điện thoại"
            rules={[
              {
                required: true,
                message: "Số điện thoại không được để trống",
              },
              {
                pattern: /^(03|05|07|08|09)\d{8}$|^\+84\d{9}$/,
                message: "Số điện thoại không hợp lệ",
              },
            ]}
            className="mb-5 w-full"
          >
            <Input
              size="large"
              prefix={
                <FontAwesomeIcon icon={faPhone} className="text-primary" />
              }
              placeholder="Nhập số điện thoại..."
            />
          </Form.Item>
          <div className="flex justify-between gap-4 py-4">
            <Button
              color="danger"
              variant="filled"
              style={{ height: 48 }}
              onClick={() => setIsModalBookingfor(false)}
            >
              <span className="text-[18px] font-bold">Huỷ</span>
            </Button>
            <Button
              htmlType="sumit"
              style={{ height: 48 }}
              className="flex-1"
              type="primary"
              loading={loading}
            >
              <span className="text-[18px] font-semibold text-white">
                Xác nhận đặt xe
              </span>
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default Map;
